import React, { createContext, FC, useContext, useState } from 'react'
import type { ProductInfoProduct } from '../../types'
import { useProductStore } from './Context'

const recommendationProductContext = createContext<ProductInfoProduct | null>(
  null,
)

export const ProductRecommendationAnchorProvider: FC<
  React.PropsWithChildren<{ product: ProductInfoProduct }>
> = ({ product, children }) => {
  const [recommendationProduct] = useState(product)

  return (
    <recommendationProductContext.Provider value={recommendationProduct}>
      {children}
    </recommendationProductContext.Provider>
  )
}

export const useProductRecommendationAnchor = () => {
  const recommendationProduct = useContext(recommendationProductContext)
  const [{ initialProduct }] = useProductStore()

  return recommendationProduct ?? initialProduct
}
